// removed by extract-text-webpack-plugin
module.exports = {"square":"src-components-StudentsNavSquare----StudentsNavSquare-module---square---37TJD","selectedSquare":"src-components-StudentsNavSquare----StudentsNavSquare-module---selectedSquare---2v4Tj","fontSample":"src-components-StudentsNavSquare----StudentsNavSquare-module---fontSample---3Na24","fontName":"src-components-StudentsNavSquare----StudentsNavSquare-module---fontName---3ZhhN","name":"src-components-StudentsNavSquare----StudentsNavSquare-module---name---224ra"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StudentsNavSquare/StudentsNavSquare.module.scss
// module id = 126
// module chunks = 29990747609436 213534597649335